import { useQuery } from 'react-query';
import { getLocalization } from '~/api/localization';

export const useApiLocalization = (keyPrefix: string, enabled = true) => {
  return useQuery(['localization', keyPrefix], () => getLocalization(keyPrefix), {
    enabled: enabled,
    staleTime: Infinity,
  });
};
